export default __webpack_public_path__ + "static/media/pic6.cf0d0d2c.jpg";